import React from 'react';

import cn from 'classnames';

import { Flex, Icon, UiText } from '@shared/ui';

import cls from './EmptyMessagesPlaceholder.module.css';

interface IEmptyMessagesPlaceholderProps {
    className?: string;
}

export const EmptyMessagesPlaceholder = ({ className }: IEmptyMessagesPlaceholderProps) => (
    <Flex
        fullWidth
        className={cn(cls.EmptyMessagesPlaceholderContainer, className)}
        direction="column"
        justify="center"
        gap={12}
    >
        <Icon iconName="comments" />
        <Flex direction="column">
            <UiText variant="subHeading" weight="bold" className={cls.EmptyMessagesHeader}>
                Комментариев пока нет
            </UiText>
            <UiText className={cls.EmptyMessagesDescription}>Оставьте первый в поле ниже</UiText>
        </Flex>
    </Flex>
);
